<template>
  <HKLMultiSelect
    :required="true"
    :showTip="false"
    :fusionInputCheckPattern="multiSelectNotEmptyPattern"
    :options="options"
    v-bind="$attrs"
    v-on="$listeners"
  />
</template>
<script>
import { unref, computed } from 'vue-demi'
import HKLMultiSelect, { SOURCE, EVENT } from '@/controls/Select/HKLMultiSelect.vue'
import { useStoreGetters } from '@/store/index'
import { getAllFloorsInTenancy } from '@/modules/ccd/tenancy/utils'
import { multiSelectNotEmptyPattern } from '@/plugin/FusionInputCheck.pattern.utils'

/**
 * @type {import('vue').Component}
 */
const MasterInviteModalFloorSelect = {
  model: {
    source: SOURCE,
    event: EVENT,
  },
  components: {
    HKLMultiSelect,
  },
  setup () {
    const { currentTenancy } = useStoreGetters('ccd', ['currentTenancy'])
    const options = computed(() => {
      return getAllFloorsInTenancy(unref(currentTenancy))
    })
    return {
      multiSelectNotEmptyPattern,
      currentTenancy,
      options,
    }
  },
}

export default MasterInviteModalFloorSelect
</script>
